
export const dataCategory = [
  {
    name: 'Automotive',
    value: 'AUTO'
  },
  {
    name: 'Beauty, spa and salon',
    value: 'BEAUTY'
  },
  {
    name: 'Clothing',
    value: 'APPAREL'
  },
  {
    name: 'Education',
    value: 'EDU'
  },
  {
    name: 'Entertainment',
    value: 'ENTERTAIN'
  },
  {
    name: 'Event planning and service',
    value: 'EVENT_PLAN'
  },
  {
    name: 'Finance and banking',
    value: 'FINANCE'
  },
  {
    name: 'Food and groceries',
    value: 'GROCERY'
  },
  {
    name: 'Public service',
    value: 'GOVT'
  },
  {
    name: 'Hotel and lodging',
    value: 'HOTEL'
  },
  {
    name: 'Medical and health',
    value: 'HEALTH'
  },
  {
    name: 'Charity',
    value: 'NONPROFIT'
  },
  {
    name: 'Professional services',
    value: 'PROF_SERVICES'
  },
  {
    name: 'Shopping and retail',
    value: 'RETAIL'
  },
  {
    name: 'Travel and transportation',
    value: 'TRAVEL'
  },
  {
    name: 'Restaurant',
    value: 'RESTAURANT'
  },
  // {
  //   name: 'NOT_A_BIZ',
  //   value: 'NOT_A_BIZ'
  // },
  {
    name: 'OTHER',
    value: 'OTHER'
  },
];

export const DefaultDate = [
  {
    name: 'Last 7 days',
    value: 'Last 7 days',
  },
  {
    name: 'Last 30 days',
    value: 'Last 30 days',
  },
  {
    name: 'Last 60 days',
    value: 'Last 60 days',
  },
  {
    name: 'Last 90 days',
    value: 'Last 90 days',
  },
]

export const dataTable = [
  {
    id: 1,
    templateName: 'sample_announcement_2023',
    category: 'Marketing',
    language: 'English (US)',
    descLanguage : 'This is your message overview',
    status: 'InReview',
    totalSent: 3663,
    totalOpened: 3663,
    lastUpdated: '08 Jan 2022, 12:45 '
  },
  {
    id: 2,
    templateName: 'ample_announcement_2023',
    category: 'Marketing',
    language: 'English (US)',
    descLanguage : 'This is your message overview',
    status: 'Requested',
    totalSent: 213,
    totalOpened: 3663,
    lastUpdated: '08 Jan 2022, 12:45 ',
  },
  {
    id: 3,
    templateName: 'mple_announcement_2023',
    category: 'Marketing',
    language: 'English (US)',
    descLanguage : 'This is your message overview',
    status: 'Active',
    totalSent: 8263,
    totalOpened: 4663,
    lastUpdated: '08 Jan 2022, 12:45 ',
  },
  {
    id: 4,
    templateName: 'ple_announcement_2023',
    category: 'Marketing',
    language: 'English (US)',
    descLanguage : 'This is your message overview',
    status: 'Rejected',
    totalSent: 5663,
    totalOpened: 1663,
    lastUpdated: '08 Jan 2022, 12:45 ',
  },
  {
    id: 5,
    templateName: 'le_announcement_2023',
    category: 'Marketing',
    language: 'English (US)',
    descLanguage : 'This is your message overview',
    status: 'active-low',
    totalSent: 3163,
    totalOpened: 2662,
    lastUpdated: '08 Jan 2022, 12:45 ',
  },
  {
    id: 6,
    templateName: 'e_announcement_2023',
    category: 'Marketing',
    language: 'English (US)',
    descLanguage : 'This is your message overview',
    status: 'paused',
    totalSent: 2663,
    totalOpened: 263,
    lastUpdated: '08 Jan 2022, 12:45 ',
  },
]

export const ListDropdownCategory =[
  {
    name: 'Authentication',
    value: 'AUTHENTICATION'
  },
  {
    name: 'Marketing',
    value: 'MARKETING'
  },
  {
    name: 'Utility',
    value: 'UTILITY'
  }
]

export const categoryTemplate = [
  {
    name: 'Marketing',
    description: 'Send promotions and information about your products, services or business',
    value: 'marketing'
  },
  {
    name: 'Utility',
    description: 'Send messages about an existing order or account',
    value: 'utility'
  },
  {
    name: 'Authentication',
    description: 'Send codes to verify a transaction or login',
    value: 'authentication'
  },
]

export const opsiHeader = [
  {
    name: "None",
    value: "NONE",
  },
  {
    name: "Media",
    value: "MEDIA",
  },
  {
    name: "Text",
    value: "TEXT",
  },
];

export const opsiButton = [
  {
    name: "None",
    value: "none",
  },
  {
    name: "Quick Reply",
    value: "quick_reply",
  },
  {
    name: "Call To Action",
    value: "call_to_action",
  },
];

export const TypeCTA = [
  {
    disable: false,
    name: "Call phone number",
    value: "call_phone_number",
  },
  {
    disable: false,
    name: "Visit Web",
    value: "visit_web",
  },
  // {
  //   disable: false,
  //   name: "Copy Promo Code",
  //   value: "copy_promo_code",
  // },
];

export const TypeQuickReply = [
  // {
  //   name: "Marketing Disapproval",
  //   value: "marketing_disapproval",
  //   disable: false,
  // },
  {
    name: "Custom",
    value: "custom",
    disable: false,
  },
];

export const UrlTypeCTA = [
  {
    name: "Static",
    value: "static",
  },
  {
    name: "Dynamic",
    value: "url_dynamic",
  },
];

export const ListCategory = [
  {
    name: "Marketing",
    value: "marketing",
  },
  {
    name: "Dynamic",
    value: "dynamic",
  },
];

export const ListDropdownStatus = [
  {
    name: "In review",
    value: "PENDING",
    checked: true
  },
  {
    name: "Rejected",
    value: "REJECTED",
    checked: true
  },
  {
    name: "Active",
    value: "APPROVED",
    checked: true
  },
  {
    name: "Paused",
    value: "PAUSED",
    checked: true
  },
  {
    name: "Disabled",
    value: "DISABLED",
    checked: true
  },
  {
    name: "Appeal Requestedy",
    value: "IN_APPEAL",
    checked: true
  }
];

export const listLanguage = [
  // {
  //   name: 'Afrikaans',
  //   value: 'af',
  //   wording: 'Hierdie kode verval in',
  //   nameTimes: 'minute',
  //   securityWord : 'Vir jou sekuriteit, moenie hierdie kode deel nie.',
  //   codeSecurityWord : 'is jou sertifiseringskode.'
  // },
  // {
  //   name: 'Albanian',
  //   value: 'sq',
  //   wording: 'Ky kod skadon në',
  //   nameTimes: 'minuta',
  //   securityWord : 'Për sigurinë tuaj, mos e shpërndani këtë kod.',
  //   codeSecurityWord : 'është kodi juaj i certifikimit.'
  // },
  // {
  //   name: 'Arabic',
  //   value: 'ar',
  //   wording: 'tantahi salahiat hadha alramz fi',
  //   nameTimes: 'daqayiq',
  //   securityWord: `li'amnik , la tusharik hadha alramz.`,
  //   codeSecurityWord : 'hu ramz altasdiq alkhasi bik.'
  // },
  // {
  //   name: 'Azerbaijani',
  //   value: 'az',
  //   wording: 'Bu kodun müddəti başa çatır',
  //   nameTimes: 'dəqiqə',
  //   securityWord: `Təhlükəsizliyiniz üçün bu kodu paylaşmayın.`,
  //   codeSecurityWord : 'sertifikat kodunuzdur.'
  // },
  // {
  //   name: 'Bengali',
  //   value: 'bn',
  //   wording: `Ē'i kōḍēra mēẏāda śēṣa habē`,
  //   nameTimes: 'Miniṭa',
  //   securityWord: `Āpanāra nirāpattāra jan'ya, ē'i kōḍa śēẏāra karabēna nā.`,
  //   codeSecurityWord : 'Āpanāra sārṭiphikēśana kōḍa.'
  // },
  // {
  //   name: 'Bulgarian',
  //   value: 'bg',
  //   wording: 'Tozi kod izticha sled',
  //   nameTimes: 'minuti',
  //   securityWord: `Za vasha sigurnost ne spodelyaĭte tozi kod.`,
  //   codeSecurityWord : 'e vashiyat sertifikatsionen kod.'
  // },
  // {
  //   name: 'Catalan',
  //   value: 'ca',
  //   wording: 'Aquest codi caduca en',
  //   nameTimes: 'minuts',
  //   securityWord: `Per la vostra seguretat, no compartiu aquest codi.`,
  //   codeSecurityWord : 'és el vostre codi de certificació.'
  // },
  // {
  //   name: 'Chinese (CHN)',
  //   value: 'zh_CN',
  //   wording: 'Cǐ dàimǎ de yǒuxiàoqí wèi',
  //   nameTimes: 'Fēnzhōng',
  //   securityWord: `Wèile nín de ānquán, qǐng wù gòngxiǎng cǐ dàimǎ.`,
  //   codeSecurityWord : 'Shì nín de yànzhèng mǎ.'
  // },
  // {
  //   name: 'Chinese (HKG)',
  //   value: 'zh_HK',
  //   wording: 'Cǐ dàimǎ de yǒuxiàoqí wèi',
  //   nameTimes: 'Fēnzhōng',
  //   securityWord: `Wèile nín de ānquán, qǐng wù gòngxiǎng cǐ dàimǎ.`,
  //   codeSecurityWord : 'Shì nín de yànzhèng mǎ.'
  // },
  // {
  //   name: 'Chinese (TAI)',
  //   value: 'zh_TW',
  //   wording: 'Cǐ dàimǎ de yǒuxiàoqí wèi',
  //   nameTimes: 'Fēnzhōng',
  //   securityWord: `Wèile nín de ānquán, qǐng wù gòngxiǎng cǐ dàimǎ.`,
  //   codeSecurityWord : 'Shì nín de yànzhèng mǎ.'
  // },
  // {
  //   name: 'Croatian',
  //   value: 'hr',
  //   wording: 'Ovaj kôd ističe za',
  //   nameTimes: 'minuta',
  //   securityWord: `Radi vaše sigurnosti, nemojte dijeliti ovaj kod.`,
  //   codeSecurityWord : 'je vaš kontrolni kod.'
  // },
  // {
  //   name: 'Czech',
  //   value: 'cs',
  //   wording: 'Platnost tohoto kódu vyprší za',
  //   nameTimes: 'minut',
  //   securityWord: `Pro vaši bezpečnost tento kód nesdílejte.`,
  //   codeSecurityWord : 'je váš ověřovací kód.'
  // },
  // {
  //   name: 'Danish',
  //   value: 'da',
  //   wording: 'Denne kode udløber om',
  //   nameTimes: 'minutter',
  //   securityWord: `Af hensyn til din sikkerhed må du ikke dele denne kode.`,
  //   codeSecurityWord : 'er din bekræftelseskode.'
  // },
  // {
  //   name: 'Dutch',
  //   value: 'nl',
  //   wording: 'Deze code verloopt over',
  //   nameTimes: 'minuten',
  //   securityWord: `Deel deze code niet voor uw veiligheid.`,
  //   codeSecurityWord : 'is uw verificatiecode.'
  // },
  {
    name: 'English',
    value: 'en',
    wording: 'This code expires in',
    nameTimes: 'minutes',
    securityWord: 'For your security, do not share this code.',
    codeSecurityWord : 'is your verification code.',
    button_text: 'Copy Code'
  },
  {
    name: 'English (UK)',
    value: 'en_GB',
    wording: 'This code expires in',
    nameTimes: 'minutes',
    securityWord: 'For your security, do not share this code.',
    codeSecurityWord : 'is your verification code.',
    button_text: 'Copy Code'
  },
  {
    name: 'English (US)',
    value: 'en_US',
    wording: 'This code expires in',
    nameTimes: 'minutes',
    securityWord: 'For your security, do not share this code.',
    codeSecurityWord : 'is your verification code.',
    button_text: 'Copy Code'
  },
  // {
  //   name: 'Estonian',
  //   value: 'et',
  //   wording: 'See kood aegub aastal',
  //   nameTimes: 'minutit',
  //   securityWord: 'Turvalisuse huvides ärge jagage seda koodi.',
  //   codeSecurityWord : 'on teie kinnituskood.'
  // },
  // {
  //   name: 'Filipino',
  //   value: 'fil',
  //   wording: 'Mag-e-expire ang code na ito sa',
  //   nameTimes: 'minuto',
  //   securityWord: 'Para sa iyong seguridad, huwag ibahagi ang code na ito.',
  //   codeSecurityWord : 'ay ang iyong verification code.'
  // },
  // {
  //   name: 'Finnish',
  //   value: 'fi',
  //   wording: 'Tämä koodi vanhenee vuonna',
  //   nameTimes: 'pöytäkirja',
  //   securityWord: 'Turvallisuutesi vuoksi älä jaa tätä koodia.',
  //   codeSecurityWord : 'on vahvistuskoodisi.'
  // },
  // {
  //   name: 'French',
  //   value: 'fr',
  //   wording: 'Ce code expire dans',
  //   nameTimes: 'minutes',
  //   securityWord: 'Pour votre sécurité, ne partagez pas ce code.',
  //   codeSecurityWord : 'est votre code de vérification.'
  // },
  // {
  //   name: 'German',
  //   value: 'de',
  //   wording: 'Dieser Code läuft in ab',
  //   nameTimes: 'Protokoll',
  //   securityWord: 'Geben Sie diesen Code zu Ihrer Sicherheit nicht weiter.',
  //   codeSecurityWord : 'ist Ihr Bestätigungscode.'
  // },
  // {
  //   name: 'Greek',
  //   value: 'el',
  //   wording: 'Aftós o kodikós lígei se',
  //   nameTimes: 'leptá',
  //   securityWord: 'Gia tin asfáleiá sas, min koinopoieíte aftón ton kodikó.',
  //   codeSecurityWord : 'eínai o kodikós epalíthefsis sas.'
  // },
  // {
  //   name: 'Gujarati',
  //   value: 'gu',
  //   wording: 'Ā kōḍanī samayasīmā samāpta thāya chē',
  //   nameTimes: 'Miniṭa',
  //   securityWord: 'Tamārī surakṣā māṭē, ā kōḍa śēra karaśō nahīṁ.',
  //   codeSecurityWord : 'Tamārō vēriphikēśana kōḍa chē.'
  // },
  // {
  //   name: 'Hausa',
  //   value: 'ha',
  //   wording: 'Wannan lambar zata ƙare a ciki',
  //   nameTimes: 'mintuna',
  //   securityWord: 'Don tsaron ku, kar a raba wannan lambar.',
  //   codeSecurityWord : 'shine lambar tabbatarwa.'
  // },
  // {
  //   name: 'Hebrew',
  //   value: 'he',
  //   wording: 'בעוד תוקף הקוד הזה יפוג',
  //   nameTimes: 'דקות',
  //   securityWord: 'למען אבטחתך, אלתשתף את הקוד הזה.',
  //   codeSecurityWord : 'הוא קוד האימות שלך.'
  // },
  // {
  //   name: 'Hindi',
  //   value: 'hi',
  //   wording: 'yah kod samaapt ho raha hai',
  //   nameTimes: 'minat',
  //   securityWord: 'apanee suraksha ke lie, is kod ko saajha na karen.',
  //   codeSecurityWord : 'aapaka satyaapan kod hai.'
  // },
  // {
  //   name: 'Hungarian',
  //   value: 'hu',
  //   wording: 'Ez a kód lejár',
  //   nameTimes: 'percek',
  //   securityWord: 'Biztonsága érdekében ne ossza meg ezt a kódot.',
  //   codeSecurityWord : 'az Ön ellenőrző kódja.'
  // },
  {
    name: 'Indonesian',
    value: 'id',
    wording: 'Kode ini kedaluwarsa dalam',
    nameTimes: 'menit',
    securityWord: 'Demi keamanan Anda, jangan bagikan kode ini.',
    codeSecurityWord : 'adalah kode verifikasi Anda.',
    button_text: 'Salin Kode'
  },
  // {
  //   name: 'Irish',
  //   value: 'ga',
  //   wording: 'Téann an cód seo in éag i',
  //   nameTimes: 'nóiméad',
  //   securityWord: 'Ar mhaithe le do shlándáil, ná roinn an cód seo.',
  //   codeSecurityWord : 'Is é do chód fíoraithe.'
  // },
  // {
  //   name: 'Italian',
  //   value: 'it',
  //   wording: 'Questo codice scade tra',
  //   nameTimes: 'minuti',
  //   securityWord: 'Per la tua sicurezza, non condividere questo codice.',
  //   codeSecurityWord : 'è il tuo codice di verifica.'
  // },
  // {
  //   name: 'Japanese',
  //   value: 'ja',
  //   wording: 'Kono kōdo no yūkō kigen wa tsugi no tōridesu',
  //   nameTimes: 'Bun',
  //   securityWord: 'Per la tua sicurezza, non condividere questo codice.',
  //   codeSecurityWord : 'Anzen no tame, kono kōdo wa kyōyū shinaide kudasai.'
  // },
  // {
  //   name: 'Kannada',
  //   value: 'kn',
  //   wording: 'Ī kōḍ avadhi mugiyuttade',
  //   nameTimes: 'Nimiṣagaḷu',
  //   securityWord: `Nim'ma bhadrategāgi, ī kōḍ annu han̄cikoḷḷabēḍi.`,
  //   codeSecurityWord : `Nim'ma pariśīlanā kōḍ āgide.`
  // },
  // {
  //   name: 'Kazakh',
  //   value: 'kk',
  //   wording: 'Bul kodtıñ merzimi ayaqtaladı',
  //   nameTimes: 'mïnwt',
  //   securityWord: 'Qawipsizdik üşin bul kodtı bölispeñiz.',
  //   codeSecurityWord : 'sizdiñ rastaw kodıñız bolıp tabıladı.'
  // },
  // {
  //   name: 'Korean',
  //   value: 'ko',
  //   wording: 'i kodeuneun da-eum gigan-e manlyodoebnida.',
  //   nameTimes: 'bun',
  //   securityWord: 'boan-eul wihae i kodeuleul gong-yuhaji masibsio.',
  //   codeSecurityWord : 'injeung kodeu-ibnida.'
  // },
  // {
  //   name: 'Kyrgyz (Kyrgyzstan)',
  //   value: 'ky_KG',
  //   wording: 'Bul koddun möönötü bütöt',
  //   nameTimes: 'münöt',
  //   securityWord: 'Koopsuzduguŋuz üçün bul koddu bölüşpöŋüz.',
  //   codeSecurityWord : 'sizdin tekşerüü koduŋuz.'
  // },
  // {
  //   name: 'Lao',
  //   value: 'lo',
  //   wording: 'lahad ni modoaiu nai',
  //   nameTimes: 'nathi',
  //   securityWord: 'pheu khuaampodphai khongchao  ya aebngpan lahad ni.',
  //   codeSecurityWord : 'aemn lahad yunyan khongthan.'
  // },
  // {
  //   name: 'Latvian',
  //   value: 'lv',
  //   wording: 'Šī koda derīguma termiņš beidzas',
  //   nameTimes: 'minūtes',
  //   securityWord: 'Drošības nolūkos nekopīgojiet šo kodu.',
  //   codeSecurityWord : 'ir jūsu verifikācijas kods.'
  // },
  // {
  //   name: 'Lithuanian',
  //   value: 'lt',
  //   wording: 'Šio kodo galiojimo laikas baigiasi',
  //   nameTimes: 'minučių',
  //   securityWord: 'Savo saugumo sumetimais nesidalykite šiuo kodu.',
  //   codeSecurityWord : 'yra jūsų patvirtinimo kodas.'
  // },
  // {
  //   name: 'Macedonian',
  //   value: 'mk',
  //   wording: 'Ovoj kod istekuva vo',
  //   nameTimes: 'minuti',
  //   securityWord: 'Za vaša bezbednost, ne go spodeluvajte ovoj kod.',
  //   codeSecurityWord : 'e vašiot kod za potvrda.'
  // },
  // {
  //   name: 'Malay',
  //   value: 'ms',
  //   wording: 'Kod ini tamat tempoh dalam',
  //   nameTimes: 'minit',
  //   securityWord: 'Untuk keselamatan anda, jangan kongsi kod ini.',
  //   codeSecurityWord : 'ialah kod pengesahan anda.'
  // },
  // {
  //   name: 'Malayalam',
  //   value: 'ml',
  //   wording: 'ee kod kaalaharanappedum',
  //   nameTimes: 'minittu',
  //   securityWord: 'ningalude surakshaykkaayi, ee kod pankidaruthu.',
  //   codeSecurityWord : 'ningalude sthireekarana kod aanu.'
  // },
  // {
  //   name: 'Marathi',
  //   value: 'mr',
  //   wording: `Hā kōḍa madhyē kālabāhya hō'īla`,
  //   nameTimes: 'Miniṭē',
  //   securityWord: `Tumacyā surakṣitatēsāṭhī, hā kōḍa śē'ara karū nakā.`,
  //   codeSecurityWord : 'Tumacā paḍatāḷaṇī kōḍa āhē.'
  // },
  // {
  //   name: 'Norwegian',
  //   value: 'nb',
  //   wording: `Denne koden utløper om`,
  //   nameTimes: 'minutter',
  //   securityWord: 'For din egen sikkerhet, ikke del denne koden.',
  //   codeSecurityWord : 'er bekreftelseskoden din.'
  // },
  // {
  //   name: 'Persian',
  //   value: 'fa',
  //   wording: `این کد منقضی می شود`,
  //   nameTimes: 'دقایق',
  //   securityWord: 'برای امنیت خود، این کد را به اشتراک نگذارید.',
  //   codeSecurityWord : 'کد تایید شما است'
  // },
  // {
  //   name: 'Polis',
  //   value: 'pl',
  //   wording: `Ten kod wygasa za`,
  //   nameTimes: 'minuty',
  //   securityWord: 'Ze względów bezpieczeństwa nie udostępniaj tego kodu.',
  //   codeSecurityWord : 'to Twój kod weryfikacyjny.'
  // },
  // {
  //   name: 'Portuguese (BR)',
  //   value: 'pt_BR',
  //   wording: `Este código expira em`,
  //   nameTimes: 'minutos',
  //   securityWord: 'Para sua segurança, não compartilhe este código.',
  //   codeSecurityWord : 'é o seu código de verificação.'
  // },
  // {
  //   name: 'Portuguese (POR)',
  //   value: 'pt_PT',
  //   wording: `Este código expira em`,
  //   nameTimes: 'minutos',
  //   securityWord: 'Para sua segurança, não compartilhe este código.',
  //   codeSecurityWord : 'é o seu código de verificação.'
  // },
  // {
  //   name: 'Punjabi',
  //   value: 'pa',
  //   wording: `Isa kōḍa dī mi'āda samāpata hō jāndī hai`,
  //   nameTimes: 'Miṭa',
  //   securityWord: `uhāḍī surakhi'ā la'ī, isa kōḍa nū sān̄jhā nā karō`,
  //   codeSecurityWord : 'Tuhāḍā puśaṭīkarana kōḍa hai.'
  // },
  // {
  //   name: 'Rumania',
  //   value: 'ro'
  // },
  // {
  //   name: 'Rusia',
  //   value: 'ru'
  // },
  // {
  //   name: 'Serbia',
  //   value: 'sr'
  // },
  // {
  //   name: 'Slowakia',
  //   value: 'sk'
  // },
  // {
  //   name: 'Slovenia',
  //   value: 'sl'
  // },
  // {
  //   name: 'Spanyol',
  //   value: 'es'
  // },
  // {
  //   name: 'Spanyol (ARG)',
  //   value: 'es_AR'
  // },
  // {
  //   name: 'Spanyol (SPA)',
  //   value: 'es_ES'
  // },
  // {
  //   name: 'Spanyol (MEX)',
  //   value: 'es_MX'
  // },
  // {
  //   name: 'Swahili',
  //   value: 'sw'
  // },
  // {
  //   name: 'Swedia',
  //   value: 'sv'
  // },
  // {
  //   name: 'Tamil',
  //   value: 'ta'
  // },
  // {
  //   name: 'Telugu',
  //   value: 'te'
  // },
  // {
  //   name: 'Thai',
  //   value: 'th'
  // },
  // {
  //   name: 'Turki',
  //   value: 'tr'
  // },
  // {
  //   name: 'Ukraina',
  //   value: 'uk'
  // },
  // {
  //   name: 'Urdu',
  //   value: 'ur'
  // },
  // {
  //   name: 'Uzbek',
  //   value: 'uz'
  // },
  // {
  //   name: 'Vietnam',
  //   value: 'vi'
  // },
  // {
  //   name: 'Zulu',
  //   value: 'zu'
  // },
]


export const isListButtonTemplate = [
  {
    title: "Quick Reply",
    value: "quick_reply",
    menus: [
      // {
      //   name: 'Marketing Disapproval',
      //   value: 'marketing_disapproval',
      //   description: `recommended (max 1 button)`
      // },
      {
        name: 'Custom',
        value: 'custom',
        description: ''
      },
    ]
  },
  {
    title: "Call to Action",
    value: "call_to_action",
    menus: [
      {
        name: 'Visit Web',
        value: 'visit_web',
        description: 'max 2 button'
      },
      {
        name: 'Call Phone Number',
        value: 'call_phone_number',
        description: 'max 1 button'
      },
      // {
      //   name: 'Copy Promo Code',
      //   value: 'copy_promo_code',
      //   description: 'max 1 button'
      // },
    ]
  },
];